'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (value) {
  if (!value) {
    return false;
  } // eslint-disable-next-line no-use-extend-native/no-use-extend-native


  if (_typeof(Symbol.observable) === 'symbol' && typeof value[Symbol.observable] === 'function') {
    // eslint-disable-next-line no-use-extend-native/no-use-extend-native
    return value === value[Symbol.observable]();
  }

  if (typeof value['@@observable'] === 'function') {
    return value === value['@@observable']();
  }

  return false;
};